export default `
    mutation unregister{
        unregister
    }
`;
